import { DatePicker } from '@lmt/unicorn-shared/app/components/common/ui-kit/inputs/date-time/DatePicker';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';

type Props = {
  from: Date | null;
  to: Date | null;
  onFromChanged: (date: Date | null) => void;
  onToChanged: (date: Date | null) => void;
};
export const GDTMessagesFilter: React.FC<Props> = React.memo(
  function GDTMessagesFilter(props) {
    const i18n = useScopedTranslation('gdt.messages.filter');
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <DatePicker
          defaultValue={props.from}
          onDateChanged={props.onFromChanged}
          withTime={true}
          displaySeconds={true}
          placeholder={i18n.t('filter_from')}
        />
        <div style={{ margin: '0 10px' }}>&ndash;</div>
        <DatePicker
          defaultValue={props.to}
          withTime={true}
          displaySeconds={true}
          onDateChanged={props.onToChanged}
          placeholder={i18n.t('filter_to')}
        />
      </div>
    );
  },
);
